import { useMutation, useQueryClient } from "@tanstack/react-query";
import { editProfilePremiumAgent } from "@/services/userprofileService";

export const useSaveBioProfile = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload) => {
      const response = await editProfilePremiumAgent(payload);
      if (response?.errorCode !== 0) {
        throw new Error(response?.errorMessage || response?.message || "Could not save your bio.");
      }
      return response;
    },
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ["userDetails"] });
      queryClient.invalidateQueries({ queryKey: ["onboardingProgress"] });
      options.onSuccess && options.onSuccess(...args);
    },
    onError: options.onError,
  });
};
